/*
*+------------------------------------------------------------------------+
*| Licensed Materials - Property of IBM
*| IBM Cognos Products: BI Dashboard
*| (C) Copyright IBM Corp. 2018
*|
*| US Government Users Restricted Rights - Use, duplication or disclosure
*| restricted by GSA ADP Schedule Contract with IBM Corp.
*+------------------------------------------------------------------------+
*/

define([], () => {

	/**
	* Upgrades the container id's when the hierarchy structure of the layout model changes.
	* It accepts an IdMap of old to new event group container id's.
	**/

	class ContainerPageIdUpgradeHelper {

		/**
		* Perform upgrade
		*
		* @param {object} spec - spec to perform upgrade on
		*
		*/
		upgrade(spec, idMap) {
			this._init(idMap);

			if (spec && Object.keys(this._containerPageIdMap).length) {
				this._upgradePageContext(spec);
				this._upgradeEventGroups(spec);
				this._upgradeWidgets(spec);
			}
		}

		_init(idMap) {
			this._containerPageIdMap = idMap || {};
		}

		_upgradePageContext(spec) {
			if (!spec.pageContext) {
				return;
			}

			for (let pageContentItem of spec.pageContext) {
				if (pageContentItem.scope) {
					let newId = this._containerPageIdMap[pageContentItem.scope];
					if (newId) {
						pageContentItem.scope = newId;
					}
				}
				if (pageContentItem.eventGroupId) {
					pageContentItem.eventGroupId = this._getUpdatedContainerId(pageContentItem.eventGroupId);
				}
			}
		}

		_upgradeEventGroups(spec) {
			if (!spec.eventGroups) {
				return;
			}

			for (let eventGroup of spec.eventGroups) {
				if (eventGroup.id) {
					eventGroup.id = this._getUpdatedContainerId(eventGroup.id);
				}
			}
		}

		_upgradeWidgets(spec) {
			if (!spec.widgets) {
				return;
			}

			for (let widgetKey in spec.widgets) {
				let widget = spec.widgets[widgetKey];
				if (widget.containerPageId) {
					let newId = this._containerPageIdMap[widget.containerPageId];
					if (newId) {
						widget.containerPageId = newId;
					}
				}
			}
		}

		_getUpdatedContainerId(eventGroupId) {
			let eventGroupParts = eventGroupId.split(':');
			let newId = this._containerPageIdMap[eventGroupParts[0]];
			if (newId) {
				eventGroupParts[0] = newId;
				return eventGroupParts.join(':');
			}
			return eventGroupId;
		}

	}
	return ContainerPageIdUpgradeHelper;

});
